<template>
  <van-popup
    v-model="myVisible"
    safe-area-inset-bottom
    position="bottom"
    closeable
    @close="hidePopup"
  >
    <div class="primary">
      <div class="empty-box">
        <van-icon class="empty" name="bulb-o" />
        <div class="text">
          未绑定设备，可以联系客服购买并绑定
        </div>
      </div>
      <a class="contact"><van-icon name="service-o" /> 联系客服</a>
    </div>
  </van-popup>
</template>

<script>
import api from '@/api'
import { popup } from '@/utils/mixins/popup'

export default {
  name: 'TraceDeviceStatus',
  mixins: [popup],
  props: {
    deviceType: {
      type: String,
      default: 'camera' // camera || iot
    },
    userId: {
      type: Number,
      default: undefined
    },
    deviceLength: {
      type: Number,
      default: 0
    }
  },
  watch: {
    userId: {
      handler(newVal) {
        if (newVal) {
          this.setDeviceLength(newVal)
        }
      },
      immediate: true
    }
  },
  methods: {
    setDeviceLength(userId) {
      if (this.$store.getters.userData.secretKey) {
        let apiName
        if (this.deviceType === 'camera') {
          apiName = 'getCameraListNoLogin'
        } else if (this.deviceType === 'iot') {
          apiName = 'getIotDeviceNoLogin'
        }
        api[apiName]({
          userId: userId
        }).then(res => {
          if (res.data && res.data.list && res.data.list.length) {
            this.$emit('update:deviceLength', res.data.list.length)
          }
        })
      }
    }
  }
}
</script>

<style lang='less' scoped>
.primary {
  text-align: center;
  padding: 20px;
}
.empty-box {

  .empty {
    font-size: 80px;
  }
  .text {
    font-size: 14px;
    color: #cccccc;
    margin-top: 10px;
  }
}
.contact  {
  display: inline-block;
  margin-top: 30px;
  padding: 6px 30px;
  border-radius: 30px;
  border: 1px solid #000000;
}
</style>
